import styles from './styles.module.scss';

export const Label = ({ children, required }) => {
    return (
        <div required={required} className={styles.label}>
            {children}
        </div>
    );
};
